import React, { useState } from "react";
import { Link } from "gatsby";

export default function CollectionsInHeader() {
  
  const [menuOpen, setMenuOpen] = useState(false)
  
  const collections= [
    {name:"Inicio", url:"/"},
    {name:"Productos", url:"/products"},
    //{name:"Baño", url:"/products/bath"},
    {name:"Refacciones", url:"/products/refacciones"},
    //{name:"Eléctricos", url:"/products/electricos"},
    //{name:"Herramientas", url:"/products/herramientas"},
    {name:"Lavabo", url:"/products/lavabo"},
    {name:"Fregadero", url:"/products/fregadero"},
  ]
  return (
    <div className="flex h-full md:mt-1">
      <button className="flex justify-end md:hidden underline underline-offset-4 text-base h-full" onClick={()=>{setMenuOpen(true)}}>Menu</button>
      <div className={`${menuOpen?"flex":"hidden"} gap-2 bg-black md:bg-primary	 h-full justify-evenly h-screen w-screen flex-col fixed z-10 top-0 left-0 md:static md:h-full md:flex md:flex-row md:w-full md:h-fit md:mx-2`}>
        {
          collections.map((collection,i)=>(
            <Link to={collection.url} className={`flex`} key={`collection ${i}`} onClick={()=>{setMenuOpen(false)}}>
              <h2 className="flex justify-center bg-primary	 h-16 md:h-4  items-center opacity-100 text-white p-2 rounded w-full md-w-1 ">
                {collection.name}    
              </h2>
            </Link>
          ))
        }

      </div>
    </div>
  );
}
